webpackJsonp([129745722219136],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MediaOverlay = exports.Media = undefined;
	
	var _Media2 = __webpack_require__(105);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MediaOverlay2 = __webpack_require__(106);
	
	var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Media3.default;
	exports.Media = _Media3.default;
	exports.MediaOverlay = _MediaOverlay3.default;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PostPreview = __webpack_require__(65);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostListing = function (_React$Component) {
	  _inherits(PostListing, _React$Component);
	
	  function PostListing() {
	    _classCallCheck(this, PostListing);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostListing.prototype.getPostList = function getPostList() {
	    var postList = [];
	    this.props.postEdges.forEach(function (postEdge) {
	      postList.push({
	        path: postEdge.node.fields.slug,
	        tags: postEdge.node.frontmatter.tags,
	        cover: postEdge.node.frontmatter.cover,
	        title: postEdge.node.frontmatter.title,
	        date: postEdge.node.frontmatter.date,
	        excerpt: postEdge.node.excerpt,
	        timeToRead: postEdge.node.timeToRead
	      });
	    });
	    return postList;
	  };
	
	  PostListing.prototype.render = function render() {
	    var postList = this.getPostList();
	    return _react2.default.createElement(
	      "div",
	      { className: "md-grid md-grid--no-spacing md-cell--middle" },
	      _react2.default.createElement(
	        "div",
	        { className: "md-grid md-cell--8 mobile-fix" },
	        postList.map(function (post) {
	          return _react2.default.createElement(_PostPreview2.default, { key: post.title, postInfo: post });
	        })
	      )
	    );
	  };
	
	  return PostListing;
	}(_react2.default.Component);
	
	exports.default = PostListing;
	module.exports = exports["default"];

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(41);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardTitle = __webpack_require__(30);
	
	var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	var _Buttons = __webpack_require__(40);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Avatars = __webpack_require__(57);
	
	var _Avatars2 = _interopRequireDefault(_Avatars);
	
	var _CardText = __webpack_require__(29);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _FontIcons = __webpack_require__(32);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Media = __webpack_require__(77);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _PostTags = __webpack_require__(81);
	
	var _PostTags2 = _interopRequireDefault(_PostTags);
	
	__webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostPreview = function (_Component) {
	  _inherits(PostPreview, _Component);
	
	  function PostPreview(props) {
	    _classCallCheck(this, PostPreview);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      mobile: true
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  PostPreview.prototype.componentDidMount = function componentDidMount() {
	    this.handleResize();
	    window.addEventListener("resize", this.handleResize);
	  };
	
	  PostPreview.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.handleResize);
	  };
	
	  PostPreview.prototype.handleResize = function handleResize() {
	    if (window.innerWidth >= 640) {
	      this.setState({ mobile: false });
	    } else {
	      this.setState({ mobile: true });
	    }
	  };
	
	  PostPreview.prototype.render = function render() {
	    var postInfo = this.props.postInfo;
	    var mobile = this.state.mobile;
	
	    var expand = mobile;
	    /* eslint no-undef: "off"*/
	    var cover = postInfo.cover.startsWith("/") ? ("") + postInfo.cover : postInfo.cover;
	    var coverHeight = mobile ? 162 : 225;
	    return _react2.default.createElement(
	      _Card2.default,
	      { key: postInfo.path, raise: true, className: "md-grid md-cell md-cell--12" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: { textDecoration: "none" }, to: postInfo.path },
	        _react2.default.createElement(
	          _Media2.default,
	          {
	            style: {
	              backgroundImage: "url(" + cover + ")",
	              height: coverHeight + "px"
	            },
	            className: "post-preview-cover"
	          },
	          _react2.default.createElement(
	            _Media.MediaOverlay,
	            null,
	            _react2.default.createElement(
	              _CardTitle2.default,
	              { title: postInfo.title },
	              _react2.default.createElement(
	                _Buttons2.default,
	                { raised: true, secondary: true, className: "md-cell--right" },
	                "Read"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_CardTitle2.default, {
	        expander: expand,
	        avatar: _react2.default.createElement(_Avatars2.default, { icon: _react2.default.createElement(_FontIcons2.default, { iconClassName: "fa fa-calendar" }) }),
	        title: "Published on " + postInfo.date,
	        subtitle: postInfo.timeToRead + " min read"
	      }),
	      _react2.default.createElement(
	        _CardText2.default,
	        { expandable: expand },
	        postInfo.excerpt,
	        _react2.default.createElement(_PostTags2.default, { tags: postInfo.tags })
	      )
	    );
	  };
	
	  return PostPreview;
	}(_react.Component);
	
	exports.default = PostPreview;
	module.exports = exports["default"];

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(28);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostListing = __webpack_require__(64);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplate = function (_React$Component) {
	  _inherits(CategoryTemplate, _React$Component);
	
	  function CategoryTemplate() {
	    _classCallCheck(this, CategoryTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplate.prototype.render = function render() {
	    var category = this.props.pathContext.category;
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      "div",
	      { className: "category-container" },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "Posts in category \"" + category + "\" | " + _SiteConfig2.default.siteTitle
	        ),
	        _react2.default.createElement("link", { rel: "canonical", href: _SiteConfig2.default.siteUrl + "/categories/" + category })
	      ),
	      _react2.default.createElement(_PostListing2.default, { postEdges: postEdges })
	    );
	  };
	
	  return CategoryTemplate;
	}(_react2.default.Component);
	
	/* eslint no-undef: "off"*/
	
	
	exports.default = CategoryTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-jsx-04a9496049863016d7c6.js